export default __webpack_public_path__ + "static/media/TugasNav.bdb44672.png";